<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <form-section :title="$t('Profiles_Overview_Title_LatestSessions')">
      <div v-if="model.length > 0">
        <div class="card" v-for="(item, index) in model" :key="index">
          <div class="info">
            <div class="date">
              <i class="el-icon-date" />
              {{ createDate(clickhouse ? item.timestamp : item.create_time) }}
            </div>
            <div class="session">
              <div class="img">
                <img
                  v-if="item.device && item.device.application_icon"
                  :src="appIcon(item.device)"
                  class="icon"
                />
                <img v-else src="@/img/icon/app-ico.png" class="icon" />
              </div>
              <div class="app-info">
                <div
                  class="title"
                  v-if="item.device && item.device.application_name"
                >
                  {{ item.device.application_name }}
                </div>
                <div v-if="item.device" class="desc">
                  {{ $t('Profiles_Devices_Field_On') }}
                  {{ itemDesc(item.device) }}
                </div>
              </div>
            </div>
          </div>
          <div class="platform">
            <img
              v-if="item.device && item.device.device_image"
              :src="deviceImage(item.device)"
            />
            <img
              v-else-if="item.device && item.device.os_logo"
              :src="osImage(item.device)"
            />
            <img v-else :src="blankImage" />
          </div>
        </div>
      </div>
      <div v-else>
        <p class="no-results-found-text">
          {{ $t('RestList_NoData') }}
        </p>
      </div>
    </form-section>
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import FormSection from '@/common/components/form/FormSection'
import RestApi from '@/core/services/RestApi'
import moment from 'moment'
import {
  projectEndpoint,
  projectTimezoneDate,
  projectTimezoneTimestamp
} from '@/core/helpers'
import { deviceDescription } from '@/modules/devices/helpers'

export default {
  name: 'LatestSessions',

  components: { FormSection, RestPage },

  props: {
    profileId: {
      type: String,
      required: true
    },
    profileNum: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      model: {}
    }
  },

  computed: {
    clickhouse() {
      return this.$hasFeature('shouldReadSessionsFromClickhouse')
    },

    fetchEndpoint() {
      const params = this.clickhouse
        ? { profile_num: this.profileNum, 'per-page': 2, page: 1 }
        : { profile_id: this.profileId, 'per-page': 2, page: 1 }

      return projectEndpoint({
        method: 'get',
        url: this.clickhouse ? 'sessions-clickhouse' : 'sessions',
        params,
        handler: data => {
          this.model = data
          Object.keys(this.model).forEach(item => {
            let endpoint = projectEndpoint({
              method: 'get',
              url: `devices/${this.model[item].device_id}?expand=application`
            })

            this.fetchItemData(this.model[item], endpoint)
          })
        }
      })
    },

    blankImage() {
      return require('@/img/devices/image-not-available.png')
    }
  },

  methods: {
    fetchItemData(item, endpoint) {
      RestApi(endpoint).then(({ data }) => {
        this.$set(item, 'device', data)
        this.$set(item, 'application', data.application)
      })
    },

    itemDesc(device) {
      return deviceDescription(device)
    },

    appIcon(device) {
      return device.application_icon
    },

    deviceImage(device) {
      return device.device_image
    },

    osImage(device) {
      return device.os_logo
    },

    createDate(modelDate) {
      if (this.$store.state.app.project) {
        moment.tz.setDefault(this.$store.state.app.project.timezone)
      }
      let date = moment(
        this.clickhouse
          ? projectTimezoneTimestamp(modelDate)
          : projectTimezoneDate(modelDate)
      )
      let difference
      if (moment().diff(date, 'days') >= 1) {
        difference = date.fromNow()
      } else {
        difference = date.calendar().split(' ')[0]
      }
      return `${difference} - ${moment(date).format('YYYY-MM-DD HH:mm')}`
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  background: #f8fafc;
  color: #4b515f;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 8px;

  .icon {
    width: 40px;
    height: 40px;
    border-radius: 4px;
  }

  .title {
    color: #4b515f;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  .info {
    padding: 16px;
    .date {
      font-size: 14px;
      color: #7e8596;
    }
    .session {
      padding-top: 20px;
      display: flex;
      .img {
        padding-right: 15px;
      }
      .app-info {
        margin-top: -3px;
      }
    }
  }
  .platform {
    padding: 16px;
    background: #f2f5f9;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    img {
      height: 80px;
      max-width: 80px;
    }
  }
}

.no-results-found-text {
  font-size: 15px;
  color: #acb0b5;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/LatestSessions.vue